<template>
  <div>
    <div class="registration">
      <div class="registration_info">
        <h1>Biscayne Legends Classic, fishing March 14th-16th, 2024</h1>
        <div class="registration_details">
          <h2 class="registration_dates">
            Registration Form
          </h2>
          <h5>Entry: $500 per team</h5>
        </div>
      </div>
      <form id="lucerne_registration" action="">
        <div class="form_section section_1">
          <div class="input_row_2">
            <inputHLM
              label="Name*"
              input-name="full_name"
              input-type="text"
              :input-required="true"
              @finished="finished"
            />
          </div>
          <div class="input_row_1">
            <inputHLM
              label="Address*"
              input-name="address"
              input-type="text"
              :input-required="true"
              @finished="finished"
            />
          </div>
          <div class="input_row_3">
            <inputHLM
              label="City*"
              input-name="city"
              input-type="text"
              :input-required="true"
              @finished="finished"
            />
            <inputHLM
              label="State*"
              input-name="state"
              input-type="text"
              :input-required="true"
              @finished="finished"
            />
            <inputHLM
              label="Zip Code*"
              input-name="zip_code"
              input-type="text"
              :input-required="true"
              @finished="finished"
            />
          </div>
          <div class="input_row_1">
            <inputHLM
              label="Phone Number*"
              input-name="phone_number"
              input-type="text"
              :input-required="true"
              @finished="finished"
            />
          </div>
          <div class="input_row_1">
            <inputHLM
              label="Email*"
              input-name="email"
              input-type="text"
              :input-required="true"
              @finished="finished"
            />
          </div>
        </div>
        <div class="input_row_full">
          <label for="">T-Shirt Size*</label>
          <radioHLM
            :input-required="true"
            :radio-info="[
              { inputName: 'angler_shirt', value: 'Small' },
              { inputName: 'angler_shirt', value: 'Medium' },
              { inputName: 'angler_shirt', value: 'Large' },
              { inputName: 'angler_shirt', value: 'X-Large' },
              { inputName: 'angler_shirt', value: 'XX-Large' },
            ]"
            @finished="finished"
          />
        </div>

        <div class="form_section section_2">
          <h2>Guide</h2>

          <div class="input_row_1">
            <inputHLM
              label="Name"
              input-name="guide_name"
              input-type="text"
              :input-required="false"
              @finished="finished"
            />
          </div>
          <div class="input_row_1">
            <inputHLM
              label="Email"
              input-name="guide_email"
              input-type="text"
              :input-required="false"
              @finished="finished"
            />
          </div>
          <div class="input_row_1">
            <inputHLM
              label="Phone"
              input-name="guide_phone"
              input-type="text"
              :input-required="false"
              @finished="finished"
            />
          </div>
          <div class="input_row_full">
            <label for="">Guide T-Shirt Size</label>
            <radioHLM
              :input-required="false"
              :radio-info="[
                { inputName: 'teammate_guide_shirt', value: 'Small' },
                { inputName: 'teammate_guide_shirt', value: 'Medium' },
                { inputName: 'teammate_guide_shirt', value: 'Large' },
                { inputName: 'teammate_guide_shirt', value: 'X-Large' },
                { inputName: 'teammate_guide_shirt', value: 'XX-Large' },
              ]"
              @finished="finished"
            />
          </div>

          <!-- <div><span class="form_erros" :class="{ show_more: missing_required_fields}">NOT ALL REQUIRED FIELDS HAVE BEEN FILLED.</span></div> -->
          <input type="submit" @click="checkForm" />
        </div>
      </form>
    </div>
    <div class="payment ">
      <div class="stripe_processing">
        <div id="loading_spinner" class="spinner">
          <div class="spinner-icon"></div>
        </div>
        <div class="background_loading"></div>
      </div>
      <div class="stripe_payment group">
        <stripePayment
          :all-form-props="this.all_fields"
          :all-charges="this.charges"
        />
      </div>
    </div>
    <div class="registration_form_success">
      <h1>
        Your payment was successful. Thank you for registering for the Biscayne
        Legends Tournament.
      </h1>
    </div>
    <div class="registration_form_failure">
      <h1>Your payment was not processed.</h1>
    </div>
  </div>
</template>
<script>
import inputHLM from "./hlm_input.vue";
import radioHLM from "./hlm_radio.vue";
// import checkHLM from "./hlm_check.vue";
import selectHLM from "./hlm_select.vue";
import EventBus from "../event_bus";
import stripePayment from "./stripe_payment.vue";

export default {
  name: "StripeForm",
  components: {
    inputHLM,
    radioHLM,
    stripePayment,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errors: [],
      required_fields: {
        full_name: "",
        address: "",
        city: "",
        state: "",
        zip_code: "",
        phone_number: "",
        email: "",
        angler_shirt: "",
      },
      all_fields: {},
      charges: {
        team_registration: 500,
      },
      wordpress: {
        ajax: "",
        nonce: "",
      },
    };
  },

  computed: {
    // has_guide() {
    //     return this.all_fields.have_guide == 'Guided' ? true : false;
    // },
    missing_required_fields() {
      if (this.errors.length != 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted: function() {
    // var stripe = Stripe('pk_test_jFBf7DhYb6NRzGeJT7mudNd300fV3IXFIZ');
    if (window.hlm_stripe_ajax) {
      this.wordpress.ajax = hlm_stripe_ajax.ajaxurl
        ? hlm_stripe_ajax.ajaxurl
        : "";
      this.wordpress.nonce = hlm_stripe_ajax.nonce ? hlm_stripe_ajax.nonce : "";
    }
  },
  methods: {
    finished(name, val) {
      if (this.required_fields.hasOwnProperty(name)) {
        this.required_fields[name] = val;
      }

      this.all_fields[name] = val;
    },

    calculatePrice(name, amount) {
      this.charges[name] = amount;
    },

    checkForm: function(e) {
      EventBus.$emit("requiredInput");

      var required_not_filled = [];

      for (const property in this.required_fields) {
        if (this.required_fields[property] != "") {
          // console.log(`${property}: ${this.required_fields[property]}`);
        } else {
          required_not_filled.push(property);
        }
      }

      if (required_not_filled.length == 0) {
        document.querySelector(".registration").style.display = "none";
        document.querySelector(".payment").style.display = "block";
      }

      e.preventDefault();
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* --- hlm registration forms --- */
button,
input[type="button"],
input[type="reset"],
input[type="submit"] {
  padding: 16px 55px !important;

  border: 1px solid;
  border-color: #ccc #ccc #bbb;
  border-radius: 3px;
  background: #e6e6e6;
  color: rgba(0, 0, 0, 0.8);
  line-height: 1;
  font-size: 12px;
  font-size: 0.75rem;
}

button:hover,
input[type="button"]:hover,
input[type="reset"]:hover,
input[type="submit"]:hover {
  border-color: #ccc #bbb #aaa;
}

button:active,
button:focus,
input[type="button"]:active,
input[type="button"]:focus,
input[type="reset"]:active,
input[type="reset"]:focus,
input[type="submit"]:active,
input[type="submit"]:focus {
  border-color: #aaa #bbb #bbb;
}

a {
  text-decoration: none;
}

input[type="text"],
input[type="email"],
input[type="url"],
input[type="password"],
input[type="range"],
input[type="date"],
input[type="month"],
input[type="week"],
input[type="time"],
input[type="datetime"],
input[type="datetime-local"],
input[type="color"],
textarea {
  border: 2px solid #ededed !important;
  border-radius: 0px;
  color: #555;
  margin: 0 0 5px 0;
  font-size: 14px !important;
  padding: 10px !important;
  font-family: "Open Sans", sans-serif;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="url"]:focus,
input[type="password"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="number"]:focus,
input[type="range"]:focus,
input[type="date"]:focus,
input[type="month"]:focus,
input[type="week"]:focus,
input[type="time"]:focus,
input[type="datetime"]:focus,
input[type="datetime-local"]:focus,
input[type="color"]:focus,
textarea:focus {
  background-color: #ededed !important;
}

textarea {
  width: 100%;
}

h1 {
  letter-spacing: 0px;
  font-weight: 400;
  font-size: 31px;
  font-family: Lovelo, sans-serif;
  line-height: 34px;
}

h5 {
  letter-spacing: 0.5px;
  font-weight: normal;
  font-family: "Open Sans", sans-serif;
  margin: 5px 0;
  font-size: 13px;
  line-height: 15px;
}

.registration {
  width: 100%;
  display: none;
  display: block;
}

.payment {
  width: 100%;
  display: none;
}

@media (min-width: 1000px) {
  .registration {
    width: 1000px;
  }

  .payment {
    width: 1000px;
  }
}

@media (min-width: 600px) {
  .registration input[type="radio"] {
    width: 20px;
  }
}

.registration * {
  box-sizing: border-box;
}

h5.registration_details_important {
  margin: 20px 0 5px 0;
}

.registration_details {
  background-color: #e5e5e5;
  padding: 10px 15px;
  margin: 20px 0 20px 0;
}

.guest_registration_details {
  background-color: #e5e5e5;
  padding: 10px 15px;
  margin: 20px 0 40px 0;
}

.raffle_details {
  padding: 10px 0px;
  margin: 20px 0 0 0;
}

.registration_details span {
  padding: 0 0 0 20px;
}

.registration_info h6 {
  letter-spacing: 0.5px;
  font-weight: 400;
  font-size: 12px;
  font-family: Lovelo, sans-serif;
  line-height: 12px;
  color: #ec1c24;
  margin: 10px 0 20px;
}

span.registration_ticket {
  padding: 0px 0px 0px 27px;
}

h6 {
  letter-spacing: 0.5px;
  font-weight: 400;
  font-size: 14px;
  font-family: Lovelo, sans-serif;
  line-height: 12px;
  color: #ec1c24;
  margin: 25px 0 10px;
}

p {
  margin: 0px;
  letter-spacing: 0px;
  font-weight: 400;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  line-height: 21px;
  padding: 0px;
}

h2.registration_dates {
  letter-spacing: 0px;
  font-weight: 400;
  font-size: 24px;
  font-family: Lovelo, sans-serif;
  line-height: 28px;
  margin: 5px 0px;
}

.registration {
  margin: 30px 0;
}

label {
  display: inline-block;
  margin: 5px 0 5px 3px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  line-height: 24px;
  text-align: left;
}

input,
textarea {
  display: block;
  margin: 0px 0;
  padding-right: 10px;
  padding-left: 10px;
  width: 100%;
  border-color: #fff;
  background-color: #fff;
  /*background-color: #eaeaea;*/
  color: #000;
  letter-spacing: 1px;
  font-weight: 200;
  font-size: 12px;
  font-family: Lovelo, sans-serif;
  line-height: 30px;
}

.registration form input[type="submit"] {
  display: inline-block;
  margin-top: 20px;
  padding: 16px 55px !important;
  width: auto;
  border: 2px #ec1c24 solid;
  border-radius: 0px;
  background-color: #ec1c24;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  font-size: 16px;
  font-family: Lovelo, sans-serif;
  line-height: 24px;
}

input.btn_raffle_submit:hover {
  background-color: #fff !important;
  color: #ec1c24;
}

input[type="checkbox"] {
  width: 20px;
  display: inline-block;
}

input[type="radio"] {
  width: 20px;
  display: inline-block;
}

input[type="radio"] {
  width: 20px;
}

@media (min-width: 600px) {
  .registration_form input[type="radio"] {
    width: 20px;
  }
}

label {
  width: calc(100% - 20px);
}

.radio_inputs,
.checkbox_inputs {
  margin: 0 0 5px;
}

.radio_inputs label,
.radio_inputs span label,
.radio_inputs input[type="radio"] .radio_inputs span input[type="radio"] {
  margin: 4px 0;
  line-height: 24px;
  text-align: left;
}

.checkbox_inputs label {
  margin: 0;
  line-height: 0px;
  text-align: left;
}

.disclaimer .checkbox_inputs label {
  line-height: 17px;
}

.checkbox_inputs input[type="checkbox"] {
  line-height: 24px;
  margin: 0;
  top: -3px;
  position: relative;
}

.radio_inputs label,
.checkbox_inputs label {
  font-weight: 400;
  font-size: 13px;
  text-transform: none;
}

.input_row_2 > div {
  width: 100%;
}

@media (min-width: 600px) {
  .input_row_2 > div {
    width: 49%;
    float: left;
  }
}

.input_row_2 div:first-child {
  margin-right: 2%;
}

.input_row_3 > div {
  width: 100%;
  float: left;
  margin-right: 0%;
}

@media (min-width: 600px) {
  .input_row_3 > div {
    width: 32%;
    float: left;
    margin-right: 2%;
  }
}

.input_row_3 div:last-child {
  margin-right: 0%;
}

div.input_row_1 {
  width: 100%;
}

@media (min-width: 600px) {
  div.input_row_1 {
    width: 49%;
  }
}

div.input_row_1 {
  width: 100%;
  max-width: 500px;
}

.input_row_full {
  width: 100%;
}

.disclaimer p {
  font-weight: 400;
  font-size: 10px;
  font-family: "Open Sans", sans-serif;
  line-height: 12px;
  margin: 5px 0;
}

select {
  margin: 0;
  display: block;
  width: 100px;
  padding: 0.5rem 0.75rem !important;
  font-size: 14px;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 2px solid #ededed !important;
  border-radius: 100px;
  box-shadow: none !important;
  touch-action: manipulation;
}

select:not([size]):not([multiple]) {
  height: calc(2.25rem + 2px);
}

.stripe_payment {
  background-color: #e5e5e5;
  padding: 30px 0;
}

.registration_form_success {
  display: none;
  padding: 30px 0;
}

.registration_form_failure {
  display: none;
  padding: 30px 0;
}

.group:before,
.group:after {
  content: "";
  display: table;
}

.group:after {
  clear: both;
}

.section_2 {
  margin: 50px 0 0 0;
}

.sponsorship {
  padding: 10px 20px;
  background: #e5e5e5;
  margin: 10px 20px;
}

.sponsorship_price {
  font-weight: 800;
  margin: 0px 20px 10px;
}

/* loader */
.stripe_processing {
  display: none;
}

#loading_spinner.spinner {
  left: 50%;
  margin-left: -20px;
  top: 50%;
  margin-top: -20px;
  position: absolute;
  z-index: 19 !important;
  animation: loading-bar-spinner 400ms linear infinite;
}

#loading_spinner.spinner .spinner-icon {
  width: 40px;
  height: 40px;
  border: solid 4px transparent;
  border-top-color: #000 !important;
  border-left-color: #000 !important;
  border-radius: 50%;
}

.background_loading {
  background: #fff;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.7;
  z-index: 15;
}

@keyframes loading-bar-spinner {
  0% {
    transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
